import { Id } from "@dgs/core";

export const ALL_CONTACT_PHONE_TYPES = [
	"privateMobile",
	"workMobile",
	"privateLandline",
	"workLandline",
	"central",
	"other",
] as const;

export type ContactPhoneType = (typeof ALL_CONTACT_PHONE_TYPES)[number];

export type IContactPhoneIndexResource = {
	id: Id;
	phoneNumber: string;
	type: ContactPhoneType;
	isPrimary: boolean;
};

export type IContactPhoneOptionResource = IContactPhoneIndexResource;

export type IContactPhoneUpdateResource = IContactPhoneIndexResource;

export type ContactPhoneSaveRequest = Omit<IContactPhoneIndexResource, "id"> & {
	contactId: Id;
};

export type IContactPhoneFormState = Omit<IContactPhoneUpdateResource, "id">;
